"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = {
  name: 'DownloadBtn',
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
};
exports.default = _default;